import React, { useState, useEffect } from 'react';
import { Flame, Award } from 'lucide-react';
import { profileAPI } from '@/utils/api';
import { useLang } from '@/utils/i18n';

const StreakBadge = () => {
  const [streak, setStreak] = useState(null);
  const { t } = useLang();

  useEffect(() => {
    (async () => {
      try {
        const res = await profileAPI.getStreak();
        setStreak(res.data);
      } catch { /* ignore */ }
    })();
  }, []);

  if (!streak || streak.current === 0) return null;

  const isWin = streak.type === 'won';

  return (
    <div
      data-testid="streak-badge"
      className={`mb-6 p-4 rounded-xl border flex items-center gap-4 ${
        isWin
          ? 'bg-gradient-to-r from-orange-500/10 to-yellow-500/10 border-orange-500/30'
          : 'bg-gradient-to-r from-red-500/10 to-red-900/10 border-red-500/30'
      }`}
    >
      <div className={`flex items-center justify-center w-14 h-14 rounded-full ${
        isWin ? 'bg-orange-500/20' : 'bg-red-500/20'
      }`}>
        <Flame className={`w-8 h-8 ${isWin ? 'text-orange-400' : 'text-red-400'}`}
          style={isWin ? { animation: 'pulse 1.5s ease-in-out infinite' } : {}}
        />
      </div>
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <span className={`text-2xl font-mono font-bold ${isWin ? 'text-orange-400' : 'text-red-400'}`}>
            {streak.current}x
          </span>
          <span className="text-sm text-gray-400">
            {isWin ? t('win_streak') : t('loss_streak')}
          </span>
        </div>
        <div className="flex items-center gap-1 mt-1 text-xs text-gray-500">
          <Award className="w-3 h-3" />
          <span>{t('best_streak')}: {streak.best}x</span>
        </div>
      </div>
      {isWin && streak.current >= 3 && (
        <div className="text-right">
          <span className="text-xs font-bold text-orange-400 bg-orange-500/20 px-2 py-1 rounded-full">
            {streak.current >= 5 ? 'FEUER!' : 'HOT'}
          </span>
        </div>
      )}
    </div>
  );
};

export default StreakBadge;
